// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gThv1","largestCol":"styles_largestCol__1r1gz","smallestCol":"styles_smallestCol__SZz6w"};